import { render, staticRenderFns } from "./DnjzhdPage.vue?vue&type=template&id=a2c7d9a2&scoped=true"
import script from "./DnjzhdPage.vue?vue&type=script&lang=js"
export * from "./DnjzhdPage.vue?vue&type=script&lang=js"
import style0 from "./DnjzhdPage.vue?vue&type=style&index=0&id=a2c7d9a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c7d9a2",
  null
  
)

export default component.exports